<template>
    <div @click.stop>
        <button @click="$store.commit('canvas/canvasHandler', null)" class="filter__close" type="button">
            <v-icon name="close" />
        </button>

        <!-- active filters tags -->
        <div class="filters" v-if="zone || filters">
            <h3 class="filters__title">Filtros Aplicados</h3>

            <div class="filters__tag">
                <div class="filters__tag__text">{{ zone }}</div>
                <button @click="clearZone()" class="filters__tag__close">
                    <v-icon name="close" />
                </button>
            </div>
        </div>
        <div class="filters__tag" v-for="filter in filters">
            <div class="filters__tag__text" v-for="value in filter">
                <div v-if="filter.priceFrom">Desde {{ value.name }}</div>
                <div v-else-if="filter.priceTo">Hasta {{ value.name }}</div>
                <div v-else-if="filter.bedrooms">
                    <div v-if="value.name === '1'">{{ value.name }} Dormitorio</div>
                    <div v-else>{{ value.name }} Dormitorios</div>
                </div>
                <div v-else-if="filter.bathrooms">
                    <div v-if="value.name === '1'">{{ value.name }} Baño</div>
                    <div v-else>{{ value.name }} Baños</div>
                </div>
                <div v-else>
                    {{ value.name }}
                </div>
            </div>
            <button @click="clearTags(filter)" class="filters__tag__close">
                <v-icon name="close" />
            </button>
        </div>

        <!-- filter location-->
        <div class="filters">
            <div class="search__location">
                <input
                    @input="suggestionsRequest"
                    @keyup="suggestionKeyup"
                    placeholder="Ingrese ciudad, localidad o barrio."
                    type="text"
                    v-model="term"
                    autocomplete="chrome-off"
                    v-on:change="changeZone"
                />
                <ul v-show="suggestions.length > 0 && suggestion">
                    <li
                        :class="{ active: currentSuggestion == inx }"
                        :key="inx"
                        @click="suggestionSelected(suggestion)"
                        @mouseover="suggestionMouseover(inx)"
                        v-for="(suggestion, inx) in suggestions"
                    >
                        {{ suggestion.description }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- filters -->
        <div class="filter">
            <!-- filter operation -->
            <div class="filter__dropdown">
                <h3 class="filter__title">
                    <span>Operacion</span>
                    <v-icon name="arrow-dropdown" />
                </h3>
                <div class="filter__options">
                    <button
                        :class="{ active: operation.key == operationActive }"
                        :key="operation.key"
                        @click="changeOperation(operation)"
                        type="button"
                        v-for="operation in operations"
                    >
                        <span>{{ operation.value }}</span>
                        <v-icon :class="{ visible: operation.key == operationActive }" name="checkmark" />
                    </button>
                </div>
            </div>
            <!-- filter type -->
            <div class="filter__dropdown">
                <h3 class="filter__title">
                    <span>Tipo</span>
                    <v-icon name="arrow-dropdown" />
                </h3>
                <div class="filter__options">
                    <button
                        :class="{ active: type.key == typeActive }"
                        :key="type.key"
                        @click="changeType(type)"
                        type="button"
                        v-for="type in types"
                    >
                        <span>{{ type.value }}</span>
                        <v-icon :class="{ visible: type.key == typeActive }" name="checkmark" />
                    </button>
                </div>
            </div>
            <!-- filter price -->
            <div class="filter__dropdown active">
                <h3 class="filter__title">
                    <span>Precio</span>
                    <v-icon name="arrow-dropdown" />
                </h3>
                <div class="filter__options filter__options--input">
                    <div class="select">
                        <v-icon name="arrow-dropdown" />
                        <select name="currency" v-model="currencySelect">
                            <!-- <option value="" disabled hidden>Seleccione la moneda</option> -->
                            <option disabled value="">Seleccione la moneda</option>
                            <option v-for="currency in currencies" :key="currency.value" v-bind:value="currency.value">
                                {{ currency.text }}
                            </option>
                        </select>
                    </div>
                    <input type="number" name="priceFrom" placeholder="Desde" v-model="priceFrom" />
                    <input type="number" name="priceTo" placeholder="Hasta" v-model="priceTo" />
                    <button @click="changePrice(priceFrom, priceTo, currencySelect)" type="button">Actualizar</button>
                </div>
            </div>
            <!-- filter bedrooms -->
            <div class="filter__dropdown">
                <h3 class="filter__title">
                    <span>Dormitorios</span>
                    <v-icon name="arrow-dropdown" />
                </h3>
                <div class="filter__options filter__options--cube">
                    <button
                        :class="{ active: bedroom.key == bedroomActive }"
                        :key="bedroom.key"
                        @click="changeBedroom(bedroom)"
                        type="button"
                        v-for="bedroom in bedrooms"
                    >
                        <span>{{ bedroom.key }}</span>
                    </button>
                </div>
            </div>
            <!-- filter bathrooms -->
            <div class="filter__dropdown">
                <h3 class="filter__title">
                    <span>Baños</span>
                    <v-icon name="arrow-dropdown" />
                </h3>
                <div class="filter__options filter__options--cube">
                    <button
                        :class="{ active: bathroom.key == bathroomActive }"
                        :key="bathroom.key"
                        @click="changeBathroom(bathroom)"
                        type="button"
                        v-for="bathroom in bathrooms"
                    >
                        <span>{{ bathroom.key }}</span>
                    </button>
                </div>
            </div>

            <!-- history -->
            <div class="filter__dropdown active" v-if="historiesSearch.length > 0">
                <h3 class="filter__title">
                    <span>Lugares buscados</span>
                    <v-icon name="arrow-dropdown" />
                </h3>
                <div class="filter__options">
                    <button
                        :class="{ active: recent.url == recentSActive }"
                        :key="recent.url"
                        @click="changeRecentS(recent)"
                        class="flag"
                        type="button"
                        v-for="recent in historiesSearch"
                    >
                        <div>
                            <img :alt="recent.name" :src="`/img/${recent.country}.svg`" />
                        </div>
                        <span>{{ recent.name }}</span>
                        <v-icon :class="{ visible: recent.url == recentSActive }" name="checkmark" />
                    </button>
                    <button @click="clearRecentS" class="filter__clear" type="button">
                        <span>Limpiar búsquedas recientes</span>
                    </button>
                </div>
            </div>
            <!-- <pre>{{ $data }}</pre> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import accents from '../helpers/accents'
import textTruncate from '../helpers/textTruncate'
import Properties from '../models/Properties.js'
import currencies from '../helpers/currencies'

import { suggestions } from '@/services/ApiMapaprop'

export default {
    data() {
        return {
            operationActive: 0,
            typeActive: 0,
            bedroomActive: 0,
            bathroomActive: 0,
            recentSActive: '',
            bedrooms: [
                { key: 1, value: '1 Dormitorio' },
                { key: 2, value: '2 Dormitorios' },
                { key: 3, value: '3 Dormitorios' },
                { key: 4, value: '4 Dormitorios' },
                { key: 5, value: '5 Dormitorios' },
                { key: 6, value: '5 Dormitorios' },
                { key: 7, value: '7 Dormitorios' },
                { key: 8, value: '8 Dormitorios' },
                { key: 9, value: '9 Dormitorios' },
                { key: 10, value: '10 Dormitorios' },
                { key: 11, value: '11 Dormitorios' },
                { key: 12, value: '12 Dormitorios' },
                { key: 13, value: '13 Dormitorios' }
            ],
            bathrooms: [
                { key: 1, value: '1 Baño' },
                { key: 2, value: '2 Baños' },
                { key: 3, value: '3 Baños' },
                { key: 4, value: '4 Baños' },
                { key: 5, value: '5 Baños' },
                { key: 6, value: '5 Baños' },
                { key: 7, value: '7 Baños' },
                { key: 8, value: '8 Baños' },
                { key: 9, value: '9 Baños' },
                { key: 10, value: '10 Baños' },
                { key: 11, value: '11 Baños' },
                { key: 12, value: '12 Baños' },
                { key: 13, value: '13 Baños' }
            ],
            recentS: [],
            priceFrom: '',
            priceTo: '',
            currencies: [],
            currencySelect: '',
            zone: '',
            term: '',
            filterTags: [],
            selected: {},
            suggestions: [],
            suggestion: false,
            currentSuggestion: 0
        }
    },
    computed: {
        ...mapGetters({
            path: 'path',
            // historiesSearch viene de local/index.ts
            historiesSearch: 'local/historiesSearch',
            // types y operations vienen de services/ApiMapaprop
            types: 'requests/types',
            operations: 'requests/operations',
            country: 'countries/country',
            filters: 'requests/filters'
        })
    },
    methods: {
        async suggestionsRequest() {
            // this.term es la expresion que ingresa por ingrese localidad
            if (this.term.length > 3) {
                const response = await suggestions({
                    country: this.country.code,
                    limit: 8,
                    term: accents(this.term)
                })
                // lo que entra por teclado en ingrese localidad
                this.selected = {}

                if (response.data.length > 0) {
                    this.suggestions = response.data
                    this.suggestion = true
                } else {
                    this.suggestions = []
                }
            }
        },
        suggestionMouseover(inx) {
            this.currentSuggestion = inx
            this.selected = this.suggestions[this.currentSuggestion]
        },
        suggestionKeyup(e) {
            if (e.key == 'ArrowUp' && this.suggestions.length > 0 && this.currentSuggestion > 0) {
                this.currentSuggestion--
                this.term = this.suggestions[this.currentSuggestion].description
                this.selected = this.suggestions[this.currentSuggestion]
            } else if (e.key == 'ArrowDown' && this.suggestions.length > 0 && this.currentSuggestion < this.suggestions.length - 1) {
                this.currentSuggestion++
                this.term = this.suggestions[this.currentSuggestion].description
                this.selected = this.suggestions[this.currentSuggestion]
            } else if (e.key == 'Enter' && this.suggestions.length > 0) {
                this.term = this.suggestions[this.currentSuggestion].description
                this.selected = this.suggestions[this.currentSuggestion]
            }
        },
        suggestionSelected(suggestion) {
            const city = suggestion.description.split(',')[0]
            this.zone = city
            this.term = ''
            this.selected = suggestion
            this.suggestions = []
        },
        filterDropdown() {
            this.$nextTick(() => {
                const elements = document.querySelectorAll('.filter__dropdown')
                for (const element of elements) {
                    const title = element.querySelector('.filter__title')
                    title.addEventListener('click', () => {
                        element.classList.toggle('active')
                    })
                }
            })
        },
        changeZone() {
            let existsZone = false
            const regExpActualLocalCode = new RegExp(this.selected.localCode)
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/')
            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('zona')) {
                    existsZone = true
                    if (regExpActualLocalCode.test(params[i])) {
                        return
                    }
                    params.splice(i, 1, `zona-${this.selected.seoUrl}_${this.selected.localCode}`)
                }
            }
            if (!existsZone) {
                params.push(`zona-${this.selected.seoUrl}_${this.selected.localCode}`)
            }
            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        clearZone() {
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/')
            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('zona')) {
                    params.splice(i, 1)
                }
            }
            this.zone = ''
            this.term = ''
            this.selected = {}
            this.suggestions = []
            this.suggestion = false
            this.currentSuggestion = 0
            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        observeActive() {
            const params = this.$route.params.pathMatch.split('/')
            // for (let i = 0; i < params.length; i++) {
            //     if (params[i].includes('operacion')) {
            //         this.operationActive = params[i].split('_')[1]
            //     }
            //     if (params[i].includes('tipo')) {
            //         this.typeActive = params[i].split('_')[1]
            //     }
            //     if (params[i].includes('dormitorios')) {
            //         this.bedroomActive = params[i].split('_')[1]
            //     }
            //     if (params[i].includes('banos')) {
            //         this.bathroomActive = params[i].split('_')[1]
            //     }
            //     if (params[i].includes('precio-min')) {
            //         this.priceFrom = params[i].split('_')[1]
            //     }
            //     if (params[i].includes('precio-max')) {
            //         this.priceTo = params[i].split('_')[1]
            //     }
            //     if (params[i].includes('moneda')) {
            //         this.currency = params[i].split('_')[1]
            //     }
            // }
            this.recentSActive = this.$route.path
            for (const param in params) {
                switch (param) {
                    case 'operacion':
                        this.operationActive = params[i].split('_')[1]
                        break
                    case 'tipo':
                        this.typeActive = params[i].split('_')[1]
                        break
                    case 'dormitorios':
                        this.bedroomActive = params[i].split('_')[1]
                        break
                    case 'banos':
                        this.bathroomActive = params[i].split('_')[1]
                        break
                    case 'precio-min':
                        this.priceFrom = params[i].split('_')[1]
                        break
                    case 'precio-max':
                        this.priceTo = params[i].split('_')[1]
                        break
                    case 'moneda':
                        this.currency = params[i].split('_')[1]
                        break
                }
            }
            const country = this.path.split('/')[1].toLowerCase()
            this.currencies = currencies[country]
            // console.log(this.recentSActive)
        },
        changeOperation(operation) {
            let existsOperation = false
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/').filter((e) => e != '')
            const value = accents(operation.value, '-')
            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('operacion')) {
                    existsOperation = true
                    if (params[i].match(operation.key)) {
                        return
                    }
                    params.splice(i, 1, `operacion-${value}_${operation.key}`)
                }
            }
            if (!existsOperation) {
                params.push(`operacion-${value}_${operation.key}`)
            }
            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        // changeOperation(operation) {
        //   console.log(operation)
        //     const country = this.country.code.toLowerCase()
        //     const params = this.$route.params.pathMatch.split('/').filter(e => e != "")
        //     console.log(params)
        //     const value = accents(operation.value, '-')
        //     let exists = false
        //     if(params.length > 0) {
        //       for (let i = 0; i < params.length; i++) {
        //         if (params[i].includes('operacion')) {
        //           if (params[i] === `operacion-${value}_${operation.key}`){
        //             return
        //           } else {
        //             exists = true
        //             params.splice(i, 1, `operacion-${value}_${operation.key}`)
        //           }
        //         }
        //       }
        //     } if (!params.length > 0 || !exists) {
        //       params.push(`operacion-${value}_${operation.key}`)
        //     }
        //     console.log(params)
        //     this.$router.push(`/${country}/buscar/${params.join('/')}`)
        //     this.$store.commit('canvas/canvasHandler', null)
        //     this.observeActive()
        // },
        changeType(type) {
            const country = this.country.code.toLowerCase()
            // se agrega el filter para que el array params no tenga un valor vacio
            const params = this.$route.params.pathMatch.split('/').filter((e) => e != '')
            const value = accents(type.value, '-')
            let exists = false
            if (params.length > 0) {
                for (let i = 0; i < params.length; i++) {
                    if (params[i].includes('tipo')) {
                        if (params[i] === `tipo-${value}_${type.key}`) {
                            return
                        } else {
                            exists = true
                            params.splice(i, 1, `tipo-${value}_${type.key}`)
                        }
                    }
                }
            }
            if (!params.length > 0 || !exists) {
                params.push(`tipo-${value}_${type.key}`)
            }

            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        changePrice(priceFrom, priceTo, currencySelect) {
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/')

            let existsCurrency = false
            let existsPriceFrom = false
            let existsPriceTo = false

            let validPriceFrom = true
            let validPriceTo = true

            let currencyValue = ''

            if (+priceFrom < 0 || !priceFrom) {
                validPriceFrom = false
                this.priceFrom = ''
            }
            if (+priceTo < 0 || !priceTo || +priceTo < +priceFrom) {
                validPriceTo = false
                this.priceTo = ''
            }
            for (let i = 0; i < params.length; i++) {
                if (!currencySelect) {
                    this.currency = ''
                }
                if (params[i].includes('precio-min')) {
                    existsPriceFrom = true
                    if (!validPriceFrom) {
                        params.splice(i, 1)
                    } else {
                        params.splice(i, 1, `precio-min_${priceFrom}`)
                    }
                }
            }
            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('precio-max')) {
                    existsPriceTo = true
                    if (!validPriceTo) {
                        params.splice(i, 1)
                    } else {
                        params.splice(i, 1, `precio-max_${priceTo}`)
                    }
                }
            }
            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('moneda')) {
                    currencyValue = params[i]
                    existsCurrency = true
                    if (!currencySelect) {
                        params.splice(i, 1)
                    } else {
                        params.splice(i, 1, `moneda_${currencySelect}`)
                    }
                }
            }

            if (!existsPriceFrom && validPriceFrom) {
                params.push(`precio-min_${priceFrom}`)
            }
            if (!existsPriceTo && validPriceTo) {
                params.push(`precio-max_${priceTo}`)
            }
            if (!existsCurrency) {
                params.push(`moneda_${currencySelect}`)
            }

            if (params.join('/') === this.$route.params.pathMatch) {
                return
            } else {
                this.$router.push(`/${country}/buscar/${params.join('/')}`)
                this.$store.commit('canvas/canvasHandler', null)
                this.observeActive()
            }
        },
        changeBedroom(bedroom) {
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/')

            let exists = false

            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('dormitorios')) {
                    if (params[i] === `dormitorios_${bedroom.key}`) {
                        return
                    } else {
                        exists = true
                        params.splice(i, 1, `dormitorios_${bedroom.key}`)
                    }
                }
            }

            if (!exists) {
                params.push(`dormitorios_${bedroom.key}`)
            }

            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        changeBathroom(bathroom) {
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/')

            let exists = false

            for (let i = 0; i < params.length; i++) {
                if (params[i].includes('banos')) {
                    if (params[i] === `banos_${bathroom.key}`) {
                        return
                    } else {
                        exists = true
                        params.splice(i, 1, `banos_${bathroom.key}`)
                    }
                }
            }

            if (!exists) {
                params.push(`banos_${bathroom.key}`)
            }

            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        changeRecentS(recentS) {
            this.$router.push(recentS.url)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        clearRecentS() {
            localStorage.removeItem('hs')
            this.$store.dispatch('local/historiesSearchAction')
        },
        clearOption(val) {
            const country = this.country.code.toLowerCase()
            const params = this.$route.params.pathMatch.split('/').filter((e) => e != '')
            for (let i = 0; i < params.length; i++) {
                switch (val) {
                    case 'operation':
                        if (params[i].includes('operacion')) {
                            params.splice(i, 1)
                        }
                        break
                    case 'type':
                        if (params[i].includes('tipo')) {
                            params.splice(i, 1)
                        }
                        break
                    case 'currency':
                        if (params[i].includes('moneda')) {
                            params.splice(i, 1)
                            this.currencySelect = ''
                        }
                        break
                    case 'priceFrom':
                        if (params[i].includes('precio-min')) {
                            params.splice(i, 1)
                            this.priceFrom = ''
                        }
                        break
                    case 'priceTo':
                        if (params[i].includes('precio-max')) {
                            params.splice(i, 1)
                            this.priceTo = ''
                        }
                        break
                    case 'bedrooms':
                        if (params[i].includes('dormitorios')) {
                            params.splice(i, 1)
                        }
                        break
                    case 'bathrooms':
                        if (params[i].includes('banos')) {
                            params.splice(i, 1)
                        }
                        break
                    default:
                        return
                }
            }
            this.$router.push(`/${country}/buscar/${params.join('/')}`)
            this.$store.commit('canvas/canvasHandler', null)
            this.observeActive()
        },
        clearTags(obj) {
            for (const value in obj) {
                this.clearOption(value)
            }
        }
    },
    created() {
        this.observeActive()
        if (this.historiesSearch.length) {
            const city = this.historiesSearch[this.historiesSearch.length - 1].name.split(',')[0]
            this.zone = city
        }
    },
    mounted() {
        this.filterDropdown()
        window.addEventListener('resize', () => {
            this.$store.commit('canvas/canvasHandler', null)
        })
    }
}
</script>

<style lang="scss">
.filter {
    margin-top: 1rem;
    user-select: none;
    border-radius: 4px;
    overflow: hidden;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(#000000, 0.2);

    &__close {
        width: 40px;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        margin-left: auto;
        margin-right: 0.5rem;
        display: none;
        background-color: transparent;
        svg {
            height: 20px;
            width: 20px;
        }
    }

    &__dropdown {
        border-bottom: 1px solid #e3e3e3;
        &:last-child {
            border-bottom: none;
        }
        &.active {
            .filter__title {
                border-bottom: 1px solid #e3e3e3;
                svg {
                    transform: rotate(180deg);
                }
            }
            .filter__options {
                display: block;
                &--cube {
                    display: grid;
                }
            }
        }
    }

    &__title {
        cursor: pointer;
        height: 40px;
        padding-left: 1rem;
        padding-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            // color: #ffffff;
        }
        svg {
            height: 20px;
            width: 20px;
            transition: all 0.4s;
            fill: #c9d700;
        }
    }

    &__options {
        display: none;
        button {
            padding-left: 1rem;
            padding-right: 1rem;
            justify-content: space-between;
            background-color: #ffffff;
            span {
                text-align: left;
            }
            svg {
                height: 20px;
                width: 20px;
                fill: #c9d700;
                visibility: hidden;
                &.visible {
                    visibility: visible;
                }
            }
            &.flag {
                div {
                    height: 16px;
                    width: 24px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        margin-right: 0.5rem;
                        object-fit: cover;
                    }
                }

                span {
                    width: calc(100% - (24px + 1rem + 20px));
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            &.active {
                background-color: #f3f3f3;
                span {
                    color: #000000;
                }
            }
        }
        &--cube {
            padding: 1rem;
            display: none;
            grid-gap: 2rem;
            grid-template-columns: repeat(4, 1fr);
            button {
                display: flex;
                align-items: center;
                justify-content: center;

                background-color: #c9d700;
                span {
                    color: #ffffff;
                }
            }
        }
        &--input {
            padding: 1rem;
            //  based in vSelect
            .select {
                position: relative;
                width: 100%;
                background-color: #ffffff;
                margin-bottom: 0.5rem;
                svg {
                    position: absolute;
                    z-index: 1;
                    top: 50%;
                    right: 0.5rem;
                    transform: translateY(-50%);
                    height: 20px;
                    width: 20px;
                    fill: #c9d700;
                }
                select {
                    position: relative;
                    z-index: 2;
                    padding-left: 0.5rem;
                    padding-right: calc(20px + 1rem);
                    // background-color: transparent;
                    border: 1px solid #e3e3e3;
                }
            }
            input {
                // display: none;
                // grid-gap: 2rem;
                // grid-template-columns: repeat(4, 1fr);
                padding-left: 0.5rem;
                padding-right: 0.5rem;
                margin-bottom: 0.5rem;
                border: 1px solid #e3e3e3;
                border-radius: 4px;
            }
            button {
                display: flex;
                align-items: center;
                justify-content: center;

                background-color: #c9d700;
                color: #ffffff;
                span {
                    color: #ffffff;
                }
            }
        }
    }

    &__clear {
        // background-color: #c9d700 !important;
        span {
            width: 100%;
            display: block;
            text-align: center !important;
            color: #c9d700;
        }
        &:hover {
            background-color: #c3c3c3;
            span {
                color: #ffffff;
            }
        }
    }

    @media (max-width: 992px) {
        position: fixed;
        z-index: 3000;
        top: 0;
        left: -280px;
        height: 100vh;
        width: 280px;
        margin-top: 0;
        border-radius: 0;
        overflow: auto;
        box-shadow: none;
        &__close {
            display: block;
        }
    }
    &__options {
        &--cube {
            grid-gap: 1rem;
        }
    }
}

.filters {
    //border-bottom: 1px solid #e3e3e3;
    margin-top: 20px;
    &__title {
        margin-bottom: 20px;
    }
    &__tag {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        max-width: 100%;
        background-color: #fafafa;
        border-radius: 2px;
        font-size: 13px;
        padding: 0.5rem;
        margin: 0rem 1rem 0.5rem 1rem;
        &__text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &__close {
            widows: unset;
            height: unset;
            background: unset;
            width: unset;
            margin-left: 10px;
            svg {
                fill: #00aad4;
                width: 20px;
                height: 20px;
            }
        }
    }
    .search__location {
        // border-bottom: 1px solid #e3e3e3;
        // // height: 41px;
        input {
            padding: 1rem;
            // margin-bottom: 1rem;
            border: 1px solid #e3e3e3;
            // border: 1px solid #666666;
            border-radius: 4px;
            font-size: 18px;
            line-height: 21px;
            box-shadow: 0 0 4px 0 rgba(#000000, 0.2);
        }
        ul {
            margin-top: 0px;
        }
    }
}
</style>
